(function(){
  'use strict';
  var $=function(s,c){return (c||document).querySelector(s)},$$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))};
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';

  function toast(t){var el=$('[data-sh-toast]');if(!el)return;el.textContent=t;el.classList.add('is-on');clearTimeout(el._t);el._t=setTimeout(function(){el.classList.remove('is-on')},2600)}
  function onView(el,cb){if(!('IntersectionObserver' in window)){cb();return}var io=new IntersectionObserver(function(e){if(e[0].isIntersecting){cb();io.disconnect()}},{threshold:.25});io.observe(el)}

  /* ---------- Gallery ---------- */
  var gal=$('[data-sh-gal]'),galTo=function(){};
  if(gal){
    var track=$('[data-sh-track]',gal),slides=$$('.sh-gal__s',gal),thumbs=$$('[data-sh-thumb]',gal),cur=0;
    var mark=function(i){thumbs.forEach(function(t,k){t.classList.toggle('is-on',k===i)});var on=thumbs[i];if(on&&on.parentNode){var p=on.parentNode;p.scrollTo({left:on.offsetLeft-p.offsetLeft-p.clientWidth/2+on.clientWidth/2,behavior:'smooth'})}};
    galTo=function(i){i=(i+slides.length)%slides.length;cur=i;track.scrollTo({left:track.clientWidth*i,behavior:'smooth'});mark(i)};
    thumbs.forEach(function(t,k){t.addEventListener('click',function(){galTo(k)})});
    var prev=$('[data-sh-prev]',gal),next=$('[data-sh-next]',gal);
    if(prev)prev.addEventListener('click',function(){galTo(cur-1)});
    if(next)next.addEventListener('click',function(){galTo(cur+1)});
    var st;track.addEventListener('scroll',function(){clearTimeout(st);st=setTimeout(function(){var i=Math.round(track.scrollLeft/track.clientWidth);if(i!==cur){cur=i;mark(i)}},60)},{passive:true});
  }

  /* ---------- Buy boxes ---------- */
  var forms=$$('[data-sh-form]');
  function money(cents){return Math.round(cents/100).toLocaleString('sv-SE').replace(/[  ]/g,' ')+' kr'}
  function applyPack(form,pack,silent){
    $$('[data-sh-pack]',form).forEach(function(p){var on=p===pack;p.classList.toggle('is-on',on);p.setAttribute('aria-checked',on?'true':'false')});
    var n=+pack.dataset.n,id=pack.dataset.id,price=+pack.dataset.price;
    $('[data-sh-vid]',form).value=id;
    $$('[data-sh-crow]',form).forEach(function(r){var i=+r.dataset.shCrow,show=i<=n;r.hidden=!show;$$('input',r).forEach(function(inp){inp.disabled=!show})});
    $$('[data-sh-price]',form).forEach(function(el){el.textContent=money(price)});
    if(!silent){forms.forEach(function(f){if(f!==form){var twin=$('[data-sh-pack][data-id="'+id+'"]',f);if(twin)applyPack(f,twin,true)}})}
    var sp=$('[data-sh-sticky-price]');if(sp)sp.textContent=money(price);
  }
  forms.forEach(function(form){
    $$('[data-sh-pack]',form).forEach(function(p){
      p.addEventListener('click',function(){applyPack(form,p)});
      p.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();applyPack(form,p)}});
    });
    var on=$('[data-sh-pack].is-on',form);if(on)applyPack(form,on,true);
    $$('[data-sh-crow] input',form).forEach(function(inp){inp.addEventListener('change',function(){if(form.dataset.shRole==='main'&&inp.dataset.mi!==undefined)galTo(+inp.dataset.mi)})});
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var btn=$('[data-sh-atc]',form),lbl=$('[data-sh-atc-label]',form),old=lbl?lbl.textContent:'';
      if(btn)btn.disabled=true;if(lbl)lbl.textContent='Lägger till…';
      fetch(root+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
        .then(function(r){if(!r.ok)return r.json().then(function(j){throw new Error(j.description||j.message||'Fel')});return r.json()})
        .then(function(){if(btn)btn.disabled=false;if(lbl)lbl.textContent=old;if(window.SHCart){window.SHCart.open()}else{window.location.href=root+'cart'}})
        .catch(function(err){toast(err.message||'Något gick fel, försök igen');if(btn)btn.disabled=false;if(lbl)lbl.textContent=old});
    });
  });

  /* show more */
  $$('[data-sh-more-btn]').forEach(function(b){b.addEventListener('click',function(){var m=$(b.dataset.shMoreBtn);if(!m)return;var o=m.classList.toggle('is-open');b.textContent=o?'Visa mindre':'Visa mer'})});

  /* ---------- Results slider ---------- */
  var res=$('[data-sh-res]');
  if(res){
    var rs=$$('.sh-res__slide',res),ri=0,cnt=$('[data-sh-res-count]',res);
    var fill=function(s){var f=$('.sh-res__fill',s),b=$('.sh-res__bar',s);if(!f)return;f.style.width='0';b.style.setProperty('--p','0%');requestAnimationFrame(function(){requestAnimationFrame(function(){f.style.width=s.dataset.p+'%';b.style.setProperty('--p',s.dataset.p+'%')})})};
    var show=function(i){ri=(i+rs.length)%rs.length;rs.forEach(function(s,k){s.classList.toggle('is-on',k===ri)});if(cnt)cnt.textContent=(ri+1)+'/'+rs.length;fill(rs[ri])};
    $('[data-sh-res-prev]',res).addEventListener('click',function(){show(ri-1)});
    $('[data-sh-res-next]',res).addEventListener('click',function(){show(ri+1)});
    onView(res,function(){show(0)});
    setInterval(function(){var r=res.getBoundingClientRect();if(document.visibilityState==='visible'&&r.top<innerHeight&&r.bottom>0&&!res.matches(':hover'))show(ri+1)},6500);
  }

  /* ---------- Stories carousel ---------- */
  $$('[data-sh-car]').forEach(function(c){
    var tr=$('.sh-stories',c),cards=$$('.sh-story',c),dots=$('.sh-dots',c);
    if(dots){cards.forEach(function(_,k){var i=document.createElement('i');if(!k)i.className='is-on';dots.appendChild(i)})}
    var step=function(){return cards[0]?cards[0].getBoundingClientRect().width+20:300};
    $('[data-sh-car-prev]',c).addEventListener('click',function(){tr.scrollBy({left:-step(),behavior:'smooth'})});
    $('[data-sh-car-next]',c).addEventListener('click',function(){if(tr.scrollLeft+tr.clientWidth>=tr.scrollWidth-4)tr.scrollTo({left:0,behavior:'smooth'});else tr.scrollBy({left:step(),behavior:'smooth'})});
    tr.addEventListener('scroll',function(){var i=Math.round(tr.scrollLeft/step());$$('i',dots).forEach(function(d,k){d.classList.toggle('is-on',k===i)})},{passive:true});
  });

  /* ---------- Chart ---------- */
  var ch=$('[data-sh-chart]');
  if(ch)onView(ch,function(){$$('[data-h]',ch).forEach(function(b){b.style.height=b.dataset.h+'%'})});

  /* ---------- Reviews ---------- */
  var rv=$('[data-sh-reviews]');
  if(rv){
    var items=$$('.sh-rv',rv),per=6,shown=per,filter='all',more=$('[data-sh-rv-more]',rv);
    var render=function(){var vis=items.filter(function(it){return filter==='all'||(it.dataset.tags||'').indexOf(filter)>-1});items.forEach(function(it){it.hidden=true});vis.slice(0,shown).forEach(function(it){it.hidden=false});more.hidden=vis.length<=shown};
    $$('[data-sh-filter]',rv).forEach(function(b){b.addEventListener('click',function(){$$('[data-sh-filter]',rv).forEach(function(x){x.classList.toggle('is-on',x===b)});filter=b.dataset.shFilter;shown=per;render()})});
    more.addEventListener('click',function(){shown+=per;render()});
    render();
    var lb=$('[data-sh-lb]');
    $$('.sh-rv__ph img',rv).forEach(function(im){im.addEventListener('click',function(){$('img',lb).src=im.dataset.full||im.src;lb.classList.add('is-on')})});
    if(lb)lb.addEventListener('click',function(){lb.classList.remove('is-on')});
  }

  /* ---------- Sticky bar ---------- */
  var sticky=$('[data-sh-sticky]'),mainAtc=$('[data-sh-role="main"] [data-sh-atc]');
  if(sticky&&mainAtc&&'IntersectionObserver' in window){
    var buy2=$('#sh-buy2'),vis={a:true,b:false};
    var upd=function(){sticky.classList.toggle('is-on',!vis.a&&!vis.b)};
    new IntersectionObserver(function(e){vis.a=e[0].isIntersecting||e[0].boundingClientRect.top>0;upd()}).observe(mainAtc);
    if(buy2)new IntersectionObserver(function(e){vis.b=e[0].isIntersecting;upd()},{threshold:.25}).observe(buy2);
    $('[data-sh-sticky-btn]',sticky).addEventListener('click',function(){var f=$('[data-sh-role="main"]');if(!f)return;if(f.requestSubmit)f.requestSubmit();else f.dispatchEvent(new Event('submit',{cancelable:true}))});
  }

  /* ---------- Reveal ---------- */
  var rvs=$$('.sh-rv-in');
  if('IntersectionObserver' in window){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}})},{threshold:.12,rootMargin:'0px 0px -40px 0px'});rvs.forEach(function(r){io.observe(r)})}else rvs.forEach(function(r){r.classList.add('is-in')});
})();
